// src/pages/hire-expert/MobileAppDeveloper.jsx
import React, { useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import "./MobileApp.css";

const MobileAppDeveloper = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Thank you ${formData.name}, we’ll contact you soon!`);
    setFormData({ name: "", email: "", phone: "", message: "" });
  };

  return (
    <>
      <Navbar />

      <div className="hire-expert-container">
        {/* Header Section */}
        <header className="hero-section">
          <h1>Hire Mobile App Developers</h1>
          <p>
            Get powerful, user-friendly mobile applications built for iOS and
            Android with our skilled app developers. We deliver seamless mobile
            experiences tailored for growth.
          </p>
          <button
            className="cta"
            onClick={() =>
              document
                .getElementById("contact-form")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            Book a Call
          </button>
         
        </header>

        {/* Stats Section */}
        <section className="stats">
          <div>
            <h2>32+</h2>
            <p>Countries Served</p>
          </div>
          <div>
            <h2>125+</h2>
            <p>In-house Experts</p>
          </div>
          <div>
            <h2>1870+</h2>
            <p>Projects Delivered</p>
          </div>
          <div>
            <h2>10+</h2>
            <p>Years Experience</p>
          </div>
        </section>

        {/* Tech Stack */}
        <section className="info-section">
          <h2>Technology Stack</h2>
          <ul>
            <li>Flutter, React Native, Swift, Objective-C, Java, Kotlin</li>
            <li>Databases: Amazon RDS, SQLite, Firebase, Amazon S3</li>
            <li>QA Tools: Unit Testing, E2E, Manual, Pen Testing, Load Testing</li>
          </ul>
        </section>

        {/* Best Practices */}
        <section className="info-section">
          <h2>Best Practices We Follow</h2>
          <ul>
            <li>In-depth requirement analysis</li>
            <li>Strategic planning + suitable tech stack selection</li>
            <li>Security-first development</li>
            <li>Continuous testing & user-centered design</li>
            <li>Localization & accessibility compliance</li>
          </ul>
        </section>

        {/* Services */}
        <section className="info-section">
          <h2>Our Mobile App Development Services</h2>
          <ul className="services-list">
            <li>Android App Development</li>
            <li>iOS App Development</li>
            <li>Native & Cross-Platform Apps</li>
            <li>Second Platform Development (Porting)</li>
            <li>Automated QA & Testing</li>
            <li>Geofencing, Push Notifications & Power Management</li>
            <li>Maintenance & 24/7 Support</li>
          </ul>
        </section>

        {/* Contact Form */}
        <section id="contact-form" className="contact-section">
          <h2>Book a Call / Contact Us</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Your Phone"
              value={formData.phone}
              onChange={handleChange}
            />
            <textarea
              name="message"
              placeholder="Tell us about your project..."
              value={formData.message}
              onChange={handleChange}
              rows="4"
              required
            ></textarea>
            <button type="submit" className="cta">
              Send Message
            </button>
          </form>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default MobileAppDeveloper;
